export const formatBytes = function (bytes: number): string {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / 1024 ** i;
  const label = sizes[i];
  const roundedSize = parseFloat(size.toFixed(2));
  return `${roundedSize} ${label}`;
};
